module.exports = __webpack_public_path__ + "6803cf186f22bba9acb3e39a963881fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/binoculars-s.png
// module id = 1797
// module chunks = 0